var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"setdark",on:{"click":_vm.setDark}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.isDark ? "mdi-lightbulb-on-outline" : "mdi-lightbulb-outline")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }